import React, { Component } from "react";
import PropTypes from "prop-types";

import "../../../styles/components/utils/components/ToggleSwitch.scss";

class ToggleSwitch extends Component {
  render() {
    return (
      <div id="toggleSwitch">
        {this.props.label && (!this.props.labelPos || this.props.labelPos === "left") && (
          <label htmlFor={this.props.name}>{this.props.label}</label>
        )}
        <div
          className={
            "toggle-container " +
            (this.props.disabled ? "disabled" : "") +
            (this.props.checked ? "green" : "")
          }
        >
          <input
            name={this.props.name}
            type="checkbox"
            checked={this.props.checked}
            onChange={this.props.onChange}
            disabled={this.props.disabled || false}
          />
          <div className="slider" />
        </div>
        {this.props.label && this.props.labelPos === "right" && (
          <label htmlFor={this.props.name}>{this.props.label}</label>
        )}
      </div>
    );
  }
}

ToggleSwitch.propTypes = {
  label: PropTypes.any,
  labelPos: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
